
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'WARFARINELDERLY',
components: {
XTable
},
data () {
return {
form: {
data1: '0',
data2: '0',
data3: '0',
data4: '0',
data5: '0',
data6: '0',
data7: '0',
data8: '0'
},
descTxt: ''
}
},
computed: {
score () {
let self = this
let form = JSON.parse(JSON.stringify(self.form))
console.log(form, 22)
for (const key in form) {
if (form.hasOwnProperty(key)) {
if (form[key] !== '0') {
form[key] = 1
} else {
form[key] = 0
}
}
}
let result = form.data1 * 0.49 + form.data2 * 0.32 + form.data3 * 0.58 + form.data4 * 0.62 +
form.data5 * 0.71 + form.data6 * 0.27 + form.data7 * 0.86 + form.data8 * 0.32
console.log(result, 777)
if (result <= 1.07) {
self.descTxt = '低风险'
} else if (result > 1.07 && result <= 2.19) {
self.descTxt = '中度风险'
} else {
self.descTxt = '高风险'
}
return result.toFixed(2)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/WARFARINELDERLY.vue